<template>
	<div class="cms-content">
		<div class="segmented-control-wrapper">
			<div class="container-title">
				<h2 class="heading-2">{{ $t('lifeEvents') }}</h2>
				<ja-button
					v-if="showCreate && isEnable"
					name="save"
					class="small"
					@click.native.prevent="onCreateNew"
					>{{ $t('createNew') }}</ja-button
				>
			</div>
			<!-- Table Life events -->
			<ja-life-events-table
				v-if="showCreate && lifeEventsData"
				:data="lifeEventsData"
				@editRow="handleEditRow"
			></ja-life-events-table>
			<!-- Create new Life events -->
			<ja-create-new-life-events
				v-if="!showCreate"
				:data-edit="dataEdit"
				@saveLifeEvent="handleSaveEvents"
				@cancel="handleCancel"
			></ja-create-new-life-events>
		</div>
	</div>
</template>
<script>
import Button from '@/components/ui/Button';
import LifeEventsTable from './LifeEventsTable.vue';
import CreateNewLifeEvents from './CreateNewLifeEvents.vue';
import LifeEventsService from '@/services/cms/LifeEventsService';
import AdminFacility from '@/mixins/AdminFacility';

export default {
	components: {
		jaLifeEventsTable: LifeEventsTable,
		jaCreateNewLifeEvents: CreateNewLifeEvents,
		jaButton: Button
	},
	mixins: [AdminFacility],
	props: {},
	data() {
		return {
			showCreate: true,
			lifeEventsData: null,
			dataEdit: null
		};
	},
	computed: {
		isEnable() {
			return (
				(this.isSuperAdmin || this.isUSAAdmin) && this.selectedFacilityId == 0
			);
		},
		isReturnOption() {
			return this.$store.state.isReturnOption;
		}
	},
	watch: {
		selectedFacility() {
			this.$store.commit('setLoading', true);
			this.showCreate = true;
			this.getLifeEvents();
		},
		isReturnOption(newValue) {
			if (newValue === true) {
				this.showCreate = true;
			} else {
				this.showCreate = false;
			}
		}
	},
	mounted() {
		this.$store.commit('setLoading', true);
		this.getLifeEvents();
	},
	methods: {
		async getLifeEvents() {
			const data = await LifeEventsService.getAll();
			this.lifeEventsData = data.sort((a, b) => (a.name < b.name ? -1 : 1));
			this.$store.commit('setLoading', false);
		},
		async onCreateNew() {
			const data = await LifeEventsService.getById();
			this.dataEdit = data;
			this.showCreate = false;
			this.$store.commit('setIsReturnOption', false);
		},
		async handleEditRow(rowData) {
			const data = await LifeEventsService.getById(rowData.lifeEvent_ID);
			this.dataEdit = data;
			this.showCreate = false;
			this.$store.commit('setIsReturnOption', false);
		},
		async handleSaveEvents(lifeEvent) {
			this.$store.commit('setLoading', true);
			await LifeEventsService.update(lifeEvent);
			await this.getLifeEvents();
			this.showCreate = true;
		},
		async handleCancel() {
			this.$store.commit('setLoading', true);
			await this.getLifeEvents();
			this.showCreate = true;
		}
	}
};
</script>
<style lang="scss" scoped>
.container-title {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.cms-content {
	margin: auto;
	max-width: 1000px;
	margin-top: 32px;
	margin-bottom: 32px;
}
</style>
